import { Rectangle } from "pixi.js";
import Layers from "slotworks/graphics/layers/layers";

/**
 * This module is intended to provide information enabling the positioning of
 * objects, relative to potentially numerous other layers in the PSD.
 *
 * I.e: Aligning images to symbols, which have a mryiad of potential related
 * layers, any of which could act as the symbol's defined border.
 *
 * Simple usecases will only need to utilise the `set` function which will
 * automatically repsition your target sprite.
 */

/**
 * Returns a rectangle which has a ratio for it's width and height.
 *
 * @method getOffsetRectangle
 */
export function getOffsetRectangle(layer: Layers, masterPosition: string, positions: string[] | string) {

    const masterRect = layer.getPosition(masterPosition);
    const staticRect = this.getFirstValidPosition(layer, positions);
    const offsetRect = new Rectangle(0, 0, 1, 1);

    if (staticRect) {
        offsetRect.x = staticRect.x - masterRect.x;
        offsetRect.y = staticRect.y - masterRect.y;
        offsetRect.width = staticRect.width / masterRect.width;
        offsetRect.height = staticRect.height / masterRect.height;
    }

    return offsetRect;
}

/**
 * Iterates thought the list of positions and uses the first one that exists as
 * a refernce for the position of the passed sprite.
 *
 * @method offsetPosition
 */
export function offsetPosition(sprite: PIXI.Sprite, layer: Layers, masterPosition: string, positions: string[] | string) {

    const offsetRect = this.getOffsetRectangle(layer, masterPosition, positions);

    sprite.x += offsetRect.x;
    sprite.y += offsetRect.y;
    sprite.width *= offsetRect.width;
    sprite.height *= offsetRect.height;
}

/**
 * finds the first position that exists and returns it.
 *
 * @method getFirstValidPosition
 */
export function getFirstValidPosition(layer: Layers, positions: string[] | string) {
    if (!Array.isArray(positions)) {
        positions = [positions];
    }

    const validPosition = positions.find((positionName) => typeof layer.getPosition(positionName) !== "undefined");
    return layer.getPosition(validPosition);
}
